import React from "react";

import Container from "./styles/Container";

// styles
import {
	PagerContainer,
} from "./styles/Pager";
import ProdctListContainer from './styles/styles.productslist';

// pagination
import Pagination from "components/Pagination";

// includes
import { Header, ProductList } from "./includes";

function Shop(props) {
	const {
		allProductsLoading,
		allProducts,
		allProductsImages,

		currentRoute,

		paginationLinks,

		currentPath,

		categoryId,

		onFilterChangeTriggered,
		handleRemoveFilter,
		handleResetAllFilters,

		filtersList,
		appliedFilters
	} = props;

	return (
		<ProdctListContainer>
			<Container className="container">
				<Header currentRoute={currentRoute} />

				<ProductList
					allProductsLoading={allProductsLoading}
					allProducts={allProducts}
					allProductsImages={allProductsImages}

					onFilterChangeTriggered={onFilterChangeTriggered}
					handleRemoveFilter={(ev, id) => handleRemoveFilter(ev, id)}
					handleResetAllFilters={handleResetAllFilters}

					filtersList={filtersList}
					appliedFilters={appliedFilters}
				/>

				<PagerContainer className="pagination-container d-flex justify-content-center">
					<Pagination
						routeName={`${currentPath}?id=${categoryId}`}
						paginationLinks={paginationLinks}
					/>
				</PagerContainer>

				{/* <Footer /> */}
			</Container>
		</ProdctListContainer>
	);
}

export default Shop;
